"use client";

import { getCookie } from "cookies-next";
import { createContext, useContext } from "react";

export function useEmbedded() {
  const closeEmbeddedWebView = () => {
    if (typeof window !== "undefined" && window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ type: "CLOSE_WEBVIEW" }),
      );
    }
  };

  const isEmbedded = useContext<boolean>(ctx);

  if (getCookie("embed")) {
    return { isEmbedded: true, closeEmbeddedWebView };
  }

  return { isEmbedded, closeEmbeddedWebView };
}

const ctx = createContext<boolean>(false);

export function EmbeddedProvider(props: {
  embedded: boolean;
  children: React.ReactNode;
}) {
  return <ctx.Provider value={props.embedded}>{props.children}</ctx.Provider>;
}
